// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TestingStatusDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class TestingStatusApiClient extends BaseCRUDApiClient<TestingStatusDto> {
  baseUrl = this.config.apiEndpoint + '/testing-status';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
